import { BackendApiUrl } from "@/functions/BackendApiUrl";
import { useSwrFetcherWithAccessToken } from "@/functions/useSwrFetcherWithAccessToken";
import useSWR from "swr";
import { BusinessUnitModel, CategoryModel } from "./interfaces/DropdownInterface";

export function GetBusinessUnitDropdownList() {
    const swrFetcher = useSwrFetcherWithAccessToken();
    const { data: businessUnits } = useSWR<BusinessUnitModel[]>(
        `${BackendApiUrl.getBusinessUnitDropdownList}`,
        swrFetcher
    );
    return businessUnits;
}

export function GetCategoryDropdownList() {
    const swrFetcher = useSwrFetcherWithAccessToken();
    const { data: categories } = useSWR<CategoryModel[]>(
        `${BackendApiUrl.getCategoriesDropdownList}`,
        swrFetcher
    );
    return categories;
}